import React from 'react';
import { Chip } from '@mui/material';
import { Icons } from '../icons/Icons';
import { SavedFilterChipProps } from '../types/savedFilters';
import { CHIP_VARIANTS, COLOR_VARIANTS } from '../constants/constants';

export default ({ filterName, onClear, hasUnsavedChanges }: SavedFilterChipProps) => {
    return (
        <Chip
            label={filterName}
            variant={CHIP_VARIANTS.outlined}
            color={hasUnsavedChanges ? COLOR_VARIANTS.error : COLOR_VARIANTS.success}
            onDelete={onClear}
            deleteIcon={<Icons.Close />}
            sx={{ height: 32, borderWidth: 1.5, borderRadius: '10px' }}
        />
    );
};
